import store from '@/store';

const tellMe = (what = null) => {
  let userRole = store.state.auth?.user?.role;
  if (userRole !== 'client') userRole = 'lab';

  const access = ACCESS_STRINGS[what] || null;
  if (!what || !access) throw new Error('Specify proper access string!');

  return access[userRole];
};

export default tellMe;

// The user can asks about the string ... with his/her role ...
export const ACCESS_STRINGS = {
  nameOrCompany: {
    client: 'Название организации',
    lab: 'Ваше имя',
  },
  ordersEndpoint: {
    client: 'client',
    lab: 'laboratory',
  },
};
